export default "__VITE_ASSET__e4344643__"